import React from 'react';
import { Link } from 'MWC';
import "../../less/reports.less";
import CustomDropdown from "../../../../auxiliary-components/shared/CustomDropdownNew";
import Preloader from "MWComponents/dest/components/Preloader";
import FilesForDownloadNew from "../../../../auxiliary-components/shared/FilesForDownloadNew/views/file.c";
import {canUseDOM} from '../../../../helpers/canUseDOM';
import TitleBlock from "../../../../auxiliary-components/shared/TitleBlock/views/TitleBlock";
import docIcon from '../../img/file_icon.svg';

export default function template() {
    const { lang } = this.props,
        dropdownContent = collection => (
              <>
                {collection.map(entry => {
                    return (
                      entry.children ?
                        <CustomDropdown chevron_icon key={entry.id} title={entry[`title_${lang}`]} classNameDropDown={'children'} classNameItems={'children'} titleTag={"h2"}>
                            {dropdownContent(entry.children)}
                        </CustomDropdown>
                        :
                        <div key={entry.id} className="files__item item-files-new">
                          <Link onClick={() => this.openDoc(entry)} target="_blank">
                            <div className="item-files-new__image">
                              <img src={docIcon} alt='doc-img'></img>
                            </div>
                            <div className="item-files-new__text">{entry[`title_${lang}`]}</div>
                          </Link>
                        </div>
                    )
                })}
              </>
        ),
        reportBlocks = this.state.collection.map(report => {
            return (
              report.group ?
                <section key={report.id} className="section">
                    <TitleBlock title={report[`title_${lang}`]} tag='h2' />
                    {report.children.map(elem => {
                        return (
                          elem.children ? <CustomDropdown key={elem.id} chevron_icon title={elem[`title_${lang}`]} classNameDropDown={"parent"} classNameItems={'parent'} titleTag={"h3"}>
                            <div className="files-new">
                   
                                {dropdownContent(elem.children)}
                          
                            </div>
                          </CustomDropdown> : ''
                        )
                    })}
                </section>
                :
                <CustomDropdown key={report.id} chevron_icon title={report[`title_${lang}`]} classNameDropDown={"parent"} classNameItems={'parent'} titleTag={"h2"}>
                  <div className="files-new">
                  
                      {dropdownContent(report.children)}
                
                  </div>
                </CustomDropdown>
            )
        });

    return (
        <div className="module-about-reports">
            <div className='container'>
                {this.state.loader ? (canUseDOM ? <Preloader /> : null) : reportBlocks}
            </div>
            <FilesForDownloadNew lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, "files_to_download")} page={"about"}/>
        </div >
    );
}
